import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignalList } from '@/components/signals';
import { CandlestickChart } from '@/components/chart';
import { useSignals, useWebSocket, useTelegram, useAuth } from '@/hooks';
import { Signal } from '@/api/types';

export const SignalsListPage: React.FC = () => {
  const navigate = useNavigate();
  const { signals, currentPrices, isLoading, error, fetchSignals } = useSignals();
  const { isConnected } = useWebSocket();
  const { showMainButton, hideMainButton, hideBackButton, impactOccurred } = useTelegram();
  const { refreshUser } = useAuth();

  // Refresh user data on mount to get latest subscription info
  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  // Set up main button for creating signal
  useEffect(() => {
    showMainButton('Create Alert', () => {
      impactOccurred('medium');
      navigate('/signals/create');
    });
    hideBackButton();

    return () => {
      hideMainButton();
    };
  }, [showMainButton, hideMainButton, hideBackButton, impactOccurred, navigate]);

  const handleSignalClick = (signal: Signal) => {
    navigate(`/signals/${signal.id}`);
  };

  const handleCreateClick = () => {
    impactOccurred('medium');
    navigate('/signals/create');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--tg-theme-bg-color)',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid var(--tg-theme-secondary-bg-color)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            fontSize: '20px',
            fontWeight: 700,
            color: 'var(--tg-theme-text-color)',
            margin: 0,
          }}
        >
          Price Alerts
        </h1>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: isConnected ? '#34c759' : '#ff3b30',
            }}
          />
          <span
            style={{
              fontSize: '12px',
              color: 'var(--tg-theme-hint-color)',
            }}
          >
            {isConnected ? 'Live' : 'Offline'}
          </span>
        </div>
      </div>

      {/* BTC Chart */}
      <div style={{ padding: '16px', paddingBottom: 0 }}>
        <CandlestickChart />
      </div>

      {/* Signal List */}
      <SignalList
        signals={signals}
        currentPrices={currentPrices}
        isLoading={isLoading}
        error={error}
        onSignalClick={handleSignalClick}
        onCreateClick={handleCreateClick}
        onRetry={fetchSignals}
      />
    </div>
  );
};
